module.exports = __webpack_public_path__ + "static/product-hunt-icon-ed06e47bd07ab307bf65ad0d4b018f0a.png";